//import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import Paper from '@mui/material/Paper';
import DocViewer, { DocViewerRenderers, PdfRenderer } from "react-doc-viewer";
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { memo } from 'react';
import { useState, useEffect} from 'react';
import { pdfjs, Document, Page } from "react-pdf";
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
//import "@cyntler/react-doc-viewer/dist/index.css";
 const CustomPDFRenderer = (props) => {
    pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/4.8.69/pdf.worker.min.mjs`;

  const [numPages, setNumPages] = useState(0);
  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }
  const { pdf } = props;
  
  const uri = props.mainState.currentDocument.uri
  const zoomLevel = props.mainState.currentDocument.zoomLevel 
  if (!uri)
    return <></>
  if (props.mainState.currentDocument.isLoading)
    return <></>
  return (
    <Document
      file={uri}
      onLoadSuccess={onDocumentLoadSuccess}
    >
      {Array.from(new Array(numPages), (el, index) => (
        <Page scale={zoomLevel} key={`page_${index + 1}`} pageNumber={index + 1} />
      ))}
    </Document>
  );
};

CustomPDFRenderer.fileTypes = ["pdf", "application/pdf"];
CustomPDFRenderer.weight = 1;

function ViewDocx(props) {
  const docUrl = props.docUrl
  const fileId = props.fileId 

  const USE_GOOGLE = false 

  return (
  <div style={{ height: "100%", width: "100%" }} >
    <Box sx={{ }} style={{ height: (props.uri ? '75vh' : '10vh'), overflow: "scroll", width: "100%", margin: "0px" }}>
      <div style={{ "position": "absolute", "display": "fixed", zIndex: 10 }} >
      </div>
      {props.uri && !USE_GOOGLE && 
        <DocViewer 
         config={{ header: {
              disableHeader: true,
             } }}  
          style={{height: "100%", width: "100%", border: 0 }} 
          prefetchMethod="GET" 
          documents={[{"fileType": props.fileType, "uri": props.uri, "zoomLevel": props.zoomLevel } ]} 
          pluginRenderers={[CustomPDFRenderer, ...DocViewerRenderers]} /> 
      }
      { props.uri && USE_GOOGLE &&
        <iframe width="100%" height="100%" frameborder="0" src={"https://docs.google.com/gview?url=" + encodeURIComponent(props.uri) + "&embedded=true&efh=false"} />
      }
      {!props.uri &&
        <Box sx={{ color: "text.disabled", bgcolor: 'text.disabled' }} style={{ height: '100%', width: '100%',  flexDirection: 'column',
    justifyContent: 'center', display: "flex" }}>
          <center>No Content Generated</center>
        </Box>
      }
    </Box>
  </div>);
}

const MemoizedViewDocx = memo((props) => ViewDocx(props))

export default ViewDocx;
